import type { ComputedRef } from 'vue'
import {
  usarCatalogoQuery,
  usarContextoCatalogo,
  type EstadoCatalogoQuery,
} from '@next/compartilhados/catalogos'

import {
  DESCRITOR_CATALOGO_LOCAL_DE_TRABALHO,
  type OpcaoLocalDeTrabalho,
} from '../catalogo-local-de-trabalho.tipos'
import { usarOperacoesCatalogoLocalDeTrabalho } from './catalogo-local-de-trabalho.injecao'

export const usarCatalogoLocalDeTrabalho = (
  habilitado?: ComputedRef<boolean>,
): EstadoCatalogoQuery<OpcaoLocalDeTrabalho> => {
  const operacoes = usarOperacoesCatalogoLocalDeTrabalho()
  return usarCatalogoQuery({
    catalogo: DESCRITOR_CATALOGO_LOCAL_DE_TRABALHO,
    contexto: usarContextoCatalogo(),
    consultar: operacoes.listarOpcoes,
    ...(habilitado ? { habilitado } : {}),
  })
}
